import React, { FC } from 'react';
import { Grid, GridItem } from '@chakra-ui/react';

import NavBar from '../NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import { Z_INDEX } from '../../assets/themes/base/space';
import { SIZES } from '../../assets/themes/base/sizes';

interface LayoutProps {
  children: React.ReactNode;
}

const LandingPageLayout: FC<LayoutProps> = (props) => {
  return (
    <Grid
      templateAreas={`"header header"
                  "main main"
                  "footer footer"`}
      gridTemplateRows={`${SIZES.H_TOP_NAV} 1fr auto`}
      gridTemplateColumns={'1fr'}
      h='100vh'
      w='100%'
      bg='background.light'
    >
      <GridItem
        area={'header'}
        position='fixed'
        w='100%'
        zIndex={Z_INDEX.TOP_NAV}
        bg='white'
      >
        <NavBar></NavBar>
      </GridItem>
      <GridItem area={'main'}>{props.children}</GridItem>
      <GridItem area={'footer'}>
        <Footer></Footer>
      </GridItem>
    </Grid>
  );
};

export default LandingPageLayout;
